export enum ActivityLogSendMethod {
  Linkedin = 'linkedin',
  InMail = 'linkedin_inmail',
  Whatsapp = 'whatsapp',
  Email = 'email',
  Indeed = 'indeed',
  Call = 'call',
  Werknl = 'werknl',
}

export enum ActivityLogAction {
  /** activity log */
  Unlocked = 'CAMPAIGN_CANDIDATE_UNLOCKED',
  Matched = 'CAMPAIGN_CANDIDATE_MATCHED',
  Hidden = 'CAMPAIGN_CANDIDATE_HIDDEN',
  Shortlisted = 'CAMPAIGN_CANDIDATE_SHORTLISTED',
  Invisible = 'CAMPAIGN_CANDIDATE_INVISIBLE',
  Contacted = 'CAMPAIGN_CANDIDATE_CONTACTED',
  MessageReceived = 'CAMPAIGN_CANDIDATE_MESSAGE_RECEIVED',
  SentToAts = 'CAMPAIGN_CANDIDATE_SENT_TO_ATS',
  LabelChanged = 'CAMPAIGN_CANDIDATE_LABEL_CHANGED',
  FollowUpPlanned = 'FOLLOW_UP_PLANNED',
  FollowUpSent = 'FOLLOW_UP_SENT',

  /** history */
  Note = 'CAMPAIGN_CANDIDATE_NOTE',
  EmailSent = 'CAMPAIGN_CANDIDATE_EMAIL_SENT',
  EmailReceived = 'CAMPAIGN_CANDIDATE_EMAIL_RECEIVED',
  InMailSent = 'CAMPAIGN_CANDIDATE_LINKEDIN_INMAIL_SENT',
  InMailReceived = 'CAMPAIGN_CANDIDATE_LINKEDIN_INMAIL_RECEIVED',
  LinkedinSent = 'CAMPAIGN_CANDIDATE_LINKEDIN_MESSAGES_SENT',
  LinkedinReceived = 'CAMPAIGN_CANDIDATE_LINKEDIN_MESSAGES_RECEIVED',
  IndeedSent = 'CAMPAIGN_CANDIDATE_INDEED_MESSAGES_SENT',
  IndeedReceived = 'CAMPAIGN_CANDIDATE_INDEED_MESSAGES_RECEIVED',

  /** ats actions */
  AtsNoteCreated = 'ATS_CANDIDATE_NOTE_CREATED',
  AtsStatusChanged = 'ATS_CANDIDATE_STATUS_CHANGED',
  AtsCandidateContact = 'ATS_CANDIDATE_CONTACT',

  /** rj communication hub actions */
  RJCommHubPipelineExpired = 'RJ_COMM_HUB_PIPELINE_EXPIRED',
  RJCommHubInitialMessageSent = 'RJ_COMM_HUB_INITIAL_MESSAGE_SENT',
  RJCommHubFollowUpPlanned = 'RJ_COMM_HUB_FOLLOW_UP_PLANNED',
  RJCommHubFollowUpSent = 'RJ_COMM_HUB_FOLLOW_UP_SENT',
  RJCommHubCandidateAccepted = 'RJ_COMM_HUB_CANDIDATE_ACCEPTED',
  RJCommHubCandidateRejected = 'RJ_COMM_HUB_CANDIDATE_REJECTED',
  CandidateAppliedRecommendation = 'CANDIDATE_APPLIED_RECOMMENDATION',

  /** calendar actions */
  CalendarInterviewInvitationSent = 'CALENDAR_INTERVIEW_INVITATION_SENT',
  CalendarInterviewInvitationAccepted = 'CALENDAR_INTERVIEW_INVITATION_ACCEPTED',
  CalendarInterviewInvitationRescheduled = 'CALENDAR_INTERVIEW_INVITATION_RESCHEDULED',
  CalendarInterviewInvitationRejected = 'CALENDAR_INTERVIEW_INVITATION_REJECTED',
}

export type ActivityLogDto = {
  id: number;
  campaign: { id: number; name: string };
  es_person_id: string;
  action: ActivityLogAction;
  tenant_id: number;
  tenant_domain: string;
  user: { id: number; first_name: string; last_name: string };
  created_at: string;
  source: string;
  is_new_message: boolean;
  metadata: {
    job_info?: null | {
      jobTitle?: string | null;
    };
    subject?: string | null;
    message?: string | null;
    sign_off?: string | null;
    schedule_follow_up_to?: string | null;
    reasons?: string[];
    added_labels?: string[];
    original?: string[];
    removed_labels?: string[];
  };
  date: string;
  candidate_notification?: {
    id: number;
    created_at: string;
    send_method: ActivityLogSendMethod;
    message: string;
    subject: string;
    sign_off: string;
    status: string;
  };
};
